function game_101()
{

}

game_101.odd_map  = {
  "8":[0,0,100,500,1000],
  "7":[0,0,50,300,600],
  "6":[0,0,15,40,200],
  "5":[0,0,10,30,160],
  "4":[0,0,10,20,100],
  "3":[0,0,5,15,60],
  "2":[0,0,5,15,40],
  "1":[0,0,5,10,20],
};

export {
  game_101
};



// WEBPACK FOOTER //
// ./src/components/slots/game_101.js